// removed by extract-text-webpack-plugin
module.exports = {"hidden":"RCx3A","visuallyhidden":"_29RtN","hide-text":"_18zY_","center":"_2tIyO","noprint":"_1kq5S","menuTrigger":"_1ssyW","menuLabelClosed":"_1mAI2","menuLabelOpen":"S2cE_","menuLabelOpen-menuOpen":"_3fWQH","menuLabelClosed-menuOpen":"_2YvVh","menuIconBox":"_3oNeL","menuIcon":"_1skde","menuIconInner":"_2mqcC","menuIconInner-menuOpen":"W5jf5 _2mqcC","mainLinks-menuOpen":"_1IWcW","mainItem":"_1yx75","navList":"_2v03k","mainLink":"MHS1F","masthead":"_2lpyM","innerContainer":"_1dPeP","logo":"PDqw0","widgets":"Bej8x","iconLabel":"_1DsS5","navSearchContainer":"_1XjNF","navSearchContainer-menuOpen":"P658L _1XjNF","vglive":"_3zpQw","tvguide":"_2hc1t"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/Masthead.scss
 ** module id = 459
 ** module chunks = 0
 **/